import FestivalView from '../../components/FestivalView/index.js';
import MediaModalPopup from '../../components/MultimediaList/MediaModalLayer.vue';
import RelatedStoryList from '../../components/Shared/RelatedStoryList.vue';
import RelatedPossessionList from '../../components/Shared/RelatedPossessionList.vue';

import SnsShareModalPopup from '../../components/SnsShareModalPopup.vue';
import PointBanner from '../../components/PointBanner.vue';
import PointModalPopup from '../../components/PointModalPopup.vue';

var app = new Vue({
    el: '#app',
    components: {
        FestivalView,
        RelatedStoryList, // 연관 이야기자료
        MediaModalPopup, // 관련 멀티미디어 상세 보기용 팝업
        RelatedPossessionList,

        SnsShareModalPopup,  // SNS 로그인 팝업
        PointBanner,     // 포인트 배너
        PointModalPopup  // 포인트 팝업
    },
    data() {
        return {
            relatedStories: [],
        }
    }
});